import { required } from 'vuelidate/lib/validators'
import Fileupload from '@/components/common/fileupload/Fileupload.vue'
import { mapState } from 'vuex';

const defaultEl = {
  id: null,
  title: {},
  content: {},
  date: '',
  signupDate: '',
  hiddenPublic: false,
  hiddenAttendees: false,
  files: []
};

export default {
  name: 'SeminarEdit',
  data () {
    return {
      editEl: null,
      apiId: null,
      loading: false,
      updatingMyStatus: false,
      loadingUsers: false,
      filteredUsers: [],
      userTableFilterValues: {
        name: '',
        email: '',
        client_names: '',
        status_id: null
      }
    }
  },
  components: {
    Fileupload
  },
  validations: {
    editEl: {
      date: { required },
      signupDate: { required }
    }
  },
  computed: {
    ...mapState(['config']),
    actions () {
      const actions = [];
      if (this.editEl) {
        const todayTime = new Date().setHours(0, 0, 0, 0);
        if (this.editEl.curUser && new Date(this.editEl.date).getTime() >= todayTime) {
          if (['ASSIGNED', 'INVITED', 'DECLINED'].includes(this.config.seminar_user_statuses[this.editEl.curUser.status_id].code)) {
            actions.push({ class: 'btn-primary', title: 'info.seminars.actions.approve', func: this.statusApprove });
          }
          if (['ASSIGNED', 'INVITED', 'APPROVED'].includes(this.config.seminar_user_statuses[this.editEl.curUser.status_id].code)) {
            actions.push({ class: 'btn-error', title: 'info.seminars.actions.decline', func: this.statusDecline });
          }
        } else if (!this.editEl.curUser && new Date(this.editEl.signupDate).getTime() >= todayTime) {
          actions.push({ class: 'btn-secondary', title: 'info.seminars.actions.signup', func: this.statusSignup });
        }
      }
      return actions;
    },
    getTitle () {
      if (this.editEl.id) {
        return this.$t('menu.seminars.edit');
      }
      return this.$t('menu.seminars.new');
    },
    canViewSettings () {
      return this.ApiRequest.userHasPermission('view-settings');
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-settings');
    },
    userTableHeaders () {
      const headers = [
        { key: 'name', label: this.$t('user.name'), filterKey: 'name' },
        { key: 'email', label: this.$t('user.email'), filterKey: 'email' },
        { key: 'client_names', label: this.$t('user.clients'), type: 'routelink', paramKey: 'name', routeTo: 'menu.client.edit', params: { clientApiId: 'api_id' }, filterKey: 'client_names' },
        { key: 'pivot.approvedAt', label: this.$t('seminar.user.approvedAt') },
        { key: 'pivot.status_id', label: this.$t('seminar.user.status'), format: 'formatFromConfig', configKey: 'seminar_user_statuses', configParam: 'name', filterKey: 'status_id' }
      ];
      if (this.canEdit) {
        headers.push({ key: 'checked', label: '', type: 'checked', class: 'text-center' });
        const toApproveStatuses = [
          this.$store.getters.getParamFromConfigByFilter('seminar_user_statuses', 'code', 'APPROVED', 'id'),
          this.$store.getters.getParamFromConfigByFilter('seminar_user_statuses', 'code', 'ATTENDED', 'id')
        ];
        const toRejectStatuses = [
          this.$store.getters.getParamFromConfigByFilter('seminar_user_statuses', 'code', 'REJECTED', 'id'),
          this.$store.getters.getParamFromConfigByFilter('seminar_user_statuses', 'code', 'DECLINED', 'id')
        ];
        const actions = [
          {
            label: this.$t('seminar.user.approve'),
            emit: 'approveUser',
            bicon: 'check',
            icon: 'secondary',
            ifconfig: { param: 'pivot.status_id', valueIn: toApproveStatuses, notCheck: true, disableNotHide: true }
          },
          {
            label: this.$t('seminar.user.reject'),
            emit: 'rejectUser',
            bicon: 'x',
            icon: 'delete',
            ifconfig: { param: 'pivot.status_id', valueIn: toRejectStatuses, notCheck: true, disableNotHide: true }
          },
          {
            label: this.$t('seminar.user.attended'),
            emit: 'attendUser',
            bicon: 'person-check-fill',
            icon: 'primary',
            ifconfig: { param: 'pivot.status_id', disableNotHide: true, value: this.$store.getters.getParamFromConfigByFilter('seminar_user_statuses', 'code', 'ATTENDED', 'id'), notCheck: true }
          },
          {
            label: this.$t('seminar.user.noattend'),
            emit: 'noAttendUser',
            bicon: 'person-x-fill',
            icon: 'warning',
            ifconfig: { param: 'pivot.status_id', disableNotHide: true, value: this.$store.getters.getParamFromConfigByFilter('seminar_user_statuses', 'code', 'NO-ATTEND', 'id'), notCheck: true }
          }
        ];
        headers.push({ key: 'actions', label: '', class: 'col-width-xl', actions: actions, displayHeaderActions: true });
      }
      return headers;
    },
    userTableFilters () {
      const filters = {};
      filters.name = { type: 'text', label: '', colOnlyFilter: true };
      filters.email = { type: 'text', label: '', colOnlyFilter: true };
      filters.client_names = { type: 'text', label: '', colOnlyFilter: true };
      filters.status_id = { type: 'select', label: '', options: this.seminarUserStatusOptions, colOnlyFilter: true };
      return filters;
    },
    userChecklistFilters () {
      const filters = {};
      filters.managers = { type: 'checkbox', label: this.$t('client.manager'), options: this.managerOptions, defaultValue: [], valueField: 'api_id' };
      filters.client_category = { type: 'checkbox', label: this.$t('client.category'), options: this.clientCategoryOptions, defaultValue: [] };
      filters.client_activeContract = {
        type: 'checkbox',
        label: this.$t('client.name') + ' - ' + this.$t('client.filters.activeContract'),
        options: this.materialGroupOptions,
        defaultValue: this.materialGroupOptions.map(function (val) {
          return val.code;
        })
      }
      filters.noSeminarSince = { type: 'date', label: this.$t('seminar.user.noSeminarSince'), defaultValue: '' };
      filters.client_primaryFillerUpdatedSince = { type: 'date', label: this.$t('client.name') + ' - ' + this.$t('client.primaryFillerUpdatedSince'), defaultValue: '' };
      filters.report_notFilledPeriod = { type: 'date-period', label: this.$t('report.notFilledPeriod'), defaultValue: null }
      filters.seminarRejectInvite = { type: 'checkbox', label: this.$t('user.seminarRejectInvite'), options: this.yesNoOptions, defaultValue: [], class: 'col-md-2' };
      filters.client_isPrimaryReportFiller = { type: 'checkbox', label: this.$t('user.isPrimaryReportFiller'), options: this.yesNoOptions, defaultValue: [], class: 'col-md-2' };
      filters.client_isBlocked = { type: 'checkbox', label: this.$t('client.name') + ' - ' + this.$t('client.isBlocked'), options: this.yesNoOptions, defaultValue: [0], class: 'col-md-2' };
      filters.client_canFillReports = { type: 'checkbox', label: this.$t('user.pivot.canFillReports'), options: this.yesNoOptions, defaultValue: [], class: 'col-md-2' };
      filters.client_isContactPerson = { type: 'checkbox', label: this.$t('client.name') + ' - ' + this.$t('user.pivot.isContactPerson'), options: this.yesNoOptions, defaultValue: [], class: 'col-md-2' };
      filters.client_isResponsiblePerson = { type: 'checkbox', label: this.$t('client.name') + ' - ' + this.$t('user.pivot.isResponsiblePerson'), options: this.yesNoOptions, defaultValue: [], class: 'col-md-2' };
      filters.client_receiveBill = { type: 'checkbox', label: this.$t('client.name') + ' - ' + this.$t('user.pivot.receiveBill'), options: this.yesNoOptions, defaultValue: [], class: 'col-md-2' };

      return filters;
    },
    clientCategoryOptions () {
      const options = this.$store.getters.getConfigOptions('client_categories', this.$i18n.locale);
      options.unshift({ text: this.$t('general.filters.without'), code: null });
      return options;
    },
    materialGroupOptions () {
      return this.$store.getters.getConfigOptions('material_groups', this.$i18n.locale, 'disabled', 0);
    },
    seminarUserStatusOptions () {
      const options = this.$store.getters.getConfigOptions('seminar_user_statuses', this.$i18n.locale);
      options.unshift({ text: '', code: null });
      return options;
    },
    yesNoOptions () {
      return this.BasicHelper.yesNoOptions();
    },
    managerOptions () {
      return this.$store.getters.getConfigOptions('managers');
    }
  },
  methods: {
    addUsers (items) {
      const reqData = { users: [] };
      items.forEach(el => {
        reqData.users.push({ api_id: el.api_id, status: 'ASSIGNED' })
      });
      this.updateUserData(reqData);
    },
    loadData () {
      if (this.apiId) {
        const self = this;
        this.ApiRequest.request('info/seminars/view/' + this.apiId, this.ApiRequest.REQUEST_GET, {}, function (response) {
          if (response.data) {
            if (response.data.users) {
              const checkedIds = (self.editEl && self.editEl.users) ? self.editEl.users.filter(el => el.checked).map(el => el.id) : [];
              for (const key in response.data.users) {
                response.data.users[key].checked = checkedIds.includes(response.data.users[key].id);
              }
            }
            self.editEl = response.data;
            self.filterUsers();
          }
        });
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }
    },
    saveGeneral () {
      this.$forceUpdate();
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading) {
        this.loading = true;
        const reqData = this.ApiRequest.createFormData(this.editEl, ['id', 'title', 'content', 'date', 'signupDate'], 'seminar', this);
        if (reqData) {
          const self = this;
          this.ApiRequest.request('info/seminars/edit/', this.ApiRequest.REQUEST_FILEUPLOAD, reqData, function (response) {
            if (response.error) {
              self.ApiRequest.displayErrorDialog(response, self);
            } else if (!self.apiId) {
              self.$router.push('/info/seminars/' + response.data.api_id + '/view');
            }
            self.loading = false;
          });
        } else {
          this.loading = false;
        }
      }
    },
    updateUserData (reqData) {
      this.loadingUsers = true;
      const self = this;
      this.ApiRequest.request('info/seminars/editusers/' + this.apiId, this.ApiRequest.REQUEST_POST, reqData, function (response) {
        if (response.error) {
          self.ApiRequest.displayErrorDialog(response, self);
        } else {
          const checkedIds = self.editEl.users.filter(el => el.checked).map(el => el.id);
          for (const key in response.data) {
            response.data[key].checked = checkedIds.includes(response.data[key].id);
          }
          self.editEl.users = response.data;
          self.filterUsers();
        }
        self.loadingUsers = false;
      });
    },
    downloadfile (key) {
      this.editEl.files[key].loading = true;
      if (this.$refs.fileupload) {
        this.$refs.fileupload.forceUpdate(key);
      } else {
        this.$forceUpdate();
      }
      const self = this;
      this.ApiRequest.request('info/seminars/downloadfile/' + this.editEl.files[key].id, this.ApiRequest.REQUEST_DOWNLOAD, [], function () {
        self.editEl.files[key].loading = false;
        if (self.$refs.fileupload) {
          self.$refs.fileupload.forceUpdate(key);
        } else {
          self.$forceUpdate();
        }
      });
    },
    setComponentData () {
      this.editEl = null;
      if (this.$route.params.seminarApiId !== 'NEW') {
        this.apiId = this.$route.params.seminarApiId;
      }
      this.loadData();
    },
    changeUserStatus (el, status) {
      /** Change user status. if (el === null), update all checked filtered items */
      const reqData = { users: [] };
      if (el) {
        reqData.users.push({ api_id: el.api_id, status: status });
      } else {
        this.filteredUsers.forEach(el => {
          if (el.checked) {
            reqData.users.push({ api_id: el.api_id, status: status });
          }
        });
      }
      this.updateUserData(reqData);
    },
    getFullUserName (item) {
      return '|B|' + item.name + '|| (' + item.email + ' - ' + item.defaultLang + ')' + '|BR|' + item.clientNames;
    },
    checkFilteredUsers (isChecked) {
      this.filteredUsers.forEach(function (el) {
        el.checked = isChecked;
      });
    },
    filterUsers () {
      /** Apply set filters to table items */
      let items = this.editEl.users;
      if (this.userTableFilterValues && this.editEl && this.editEl.users && this.$refs.seminarUserTable) {
        const filterVals = this.$refs.seminarUserTable.getFilterValues();
        const statusId = this.$store.getters.getParamFromConfigByFilter('seminar_user_statuses', 'code', filterVals.status_id, 'id');
        items = items.filter(function (el) {
          let display = true;
          for (const key in filterVals) {
            if (key === 'status_id') {
              display = display && (statusId === null || el.pivot.status_id === statusId);
            } else if (Object.prototype.hasOwnProperty.call(el, key) && (filterVals[key] !== null) && display) {
              if (key === 'client_names') {
                let clientMatch = false;
                for (const key2 in el[key]) {
                  clientMatch = clientMatch || (el[key][key2].name.toLowerCase().includes(filterVals[key]));
                }
                display = clientMatch;
              } else {
                display = display && (el[key] && el[key].toLowerCase().includes(filterVals[key]));
              }
            }
          }
          return display;
        });
      }
      this.filteredUsers = items;
    },
    changeMyStatus (status) {
      const self = this;
      this.updatingMyStatus = true;
      this.ApiRequest.request('info/seminars/updatemystatus/' + this.apiId, this.ApiRequest.REQUEST_POST, { status: status }, function (response) {
        if (response.error) {
          self.ApiRequest.displayErrorDialog(response, self);
        } else {
          self.editEl.curUser = response.data;
        }
        self.updatingMyStatus = false;
      });
    },
    statusApprove () {
      this.changeMyStatus('APPROVED');
    },
    statusDecline () {
      this.changeMyStatus('DECLINED');
    },
    statusSignup () {
      this.changeMyStatus('SIGNED-UP');
    }
  },
  mounted () {
    this.setComponentData();
  },
  watch: {
    '$route' () {
      this.setComponentData();
    }
  }
}
